import React from "react";
import { Box, Typography, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useSEO from "../../../../seo/use-seo";
import StandardPageHelmet from "../../../../seo/components/StandardPageHelmet";

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    backgroundColor: "#0f0f0f",
    minHeight: "100vh",
    color: "#fff",
    lineHeight: 1.6,
  },
  title: {
    color: "#FE5A97",
    marginBottom: theme.spacing(3),
    fontWeight: "bold",
  },
  subtitle: {
    color: "#FE5A97",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
  },
  paragraph: {
    marginBottom: theme.spacing(2),
    color: "#fff",
  },
  listItem: {
    marginBottom: theme.spacing(1),
    color: "#fff",
    paddingLeft: theme.spacing(2),
  },
  link: {
    color: "#FE5A97",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default function ContentProviderAgreement() {
  const classes = useStyles();
  const seo = useSEO("content-provider-agreement");

  return (
    <>
      <StandardPageHelmet seo={seo} />
      <Container maxWidth="md" className={classes.container}>
        <Typography variant="h3" className={classes.title}>
          Content Provider Agreement
        </Typography>

        <Typography variant="h5" className={classes.subtitle}>
          1. Eligibility
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          By uploading, generating, or submitting any content to the Platform, you
          confirm that you are at least eighteen (18) years old and legally
          permitted to enter into this agreement.
        </Typography>

        <Typography variant="h5" className={classes.subtitle}>
          2. Prohibited Content
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          You agree not to upload, publish, or distribute any content that:
        </Typography>
        <Box component="ul" style={{ paddingLeft: "20px" }}>
          <li className={classes.listItem}>is illegal under applicable laws;</li>
          <li className={classes.listItem}>
            violates CCBill Standards or card network rules;
              </li>
          <li className={classes.listItem}>involves minors in any way;</li>
          <li className={classes.listItem}>
            depicts non-consensual, exploitative, or otherwise unlawful activity.
              </li>
        </Box>

        <Typography variant="h5" className={classes.subtitle}>
          3. Consent and Rights of Persons Depicted
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          You represent and warrant that <strong>for every person depicted in the content</strong>, you have obtained and will keep on record{" "}
          <strong>written consent</strong>, including:
        </Typography>
        <Box component="ul" style={{ paddingLeft: "20px" }}>
          <li className={classes.listItem}>
            consent to be depicted in the content;
              </li>
          <li className={classes.listItem}>
            consent for the public distribution of the content;
                </li>
          <li className={classes.listItem}>
            consent to upload and publish the content on the Merchant's website;
              </li>
          <li className={classes.listItem}>
            if the content is downloadable, consent to allow other users to download
            the content.
              </li>
        </Box>
        <Typography variant="body1" className={classes.paragraph}>
          You agree to retain all consent records and provide them to the Merchant
          or its payment processors upon request.
        </Typography>

        <Typography variant="h5" className={classes.subtitle}>
          4. Age and Identity Verification
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          You are solely responsible for verifying the <strong>identity and age</strong> of all persons depicted in the content and confirm that{" "}
          <strong>all persons are adults (18+)</strong>.
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          You agree to maintain valid supporting documentation (government-issued
          ID and consent forms) and to provide such documentation upon request by
          the Merchant or CCBill.
        </Typography>

        <Typography variant="h5" className={classes.subtitle}>
          5. Compliance and Cooperation
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          You agree to fully cooperate with the Merchant and CCBill in connection
          with any compliance review, investigation, or request related to your
          content.
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          Failure to comply with this agreement may result in content removal,
          account suspension, or termination.
        </Typography>

        <Typography variant="h5" className={classes.subtitle}>
          6. Acceptance
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          By uploading content or using creator features on the Platform, you
          acknowledge that you have read, understood, and agreed to this Content
          Provider Agreement.
        </Typography>

        <Box
          style={{
            backgroundColor: "#1a1a1a",
            border: "1px solid #333",
            borderRadius: "8px",
            padding: "16px",
            marginTop: "24px",
          }}
        >
          <Typography variant="body1" className={classes.paragraph}>
            <strong>Questions?</strong> Contact us at:{" "}
            <a href="mailto:support@sugarcribs.com" className={classes.link}>
              support@sugarcribs.com
            </a>
          </Typography>
        </Box>
      </Container>
    </>
  );
}
